import { createContext, useContext } from 'react';
export const FieldValidationContext = createContext(null);
export const useFieldValidation = ()=>useContext(FieldValidationContext) || {};

//# sourceMappingURL=field-validation-context.js.map